








import { defineComponent, ref, useFetch, useContext } from '@nuxtjs/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { appendStylesFromText, parseClasses } from '~/utils/solepro/functions';
import { useContent } from "~/composables";
import { getAsJSON } from '~/utils/solepro/CmsComponentAggregator';
import { PageBuilderType } from '~/types/solepro/PageBuilder';
import CmsContent from '~/modules/catalog/category/components/cms/CmsContent.vue';


export default defineComponent({
    mixins: [PageBuilderComponent],
    components: { PageBuilderComponent, CmsContent },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const widget = ref<string | null>(null);
        const { loadBlocks } = useContent();
        const {isDev} =  useContext();

        if(content.blockId){
            useFetch(async ()=>{
                const cmsWidget = await loadBlocks({ identifiers: [content.blockId] });
                //widget.value = getAsJSON(cmsWidget[0].content, false, isDev);
                widget.value = parseClasses(cmsWidget[0].content)
            })
        }
        return { content, widget }
    },
    mounted(){
        if(this.content.pageBuilderStyleNode) appendStylesFromText(this.content.pageBuilderStyleNode);

    }
})
